//클래스 만들기
//import { tanhDependencies } from 'mathjs';
import QRCode from 'qrcode'
import JsBarcode from 'jsbarcode';

class DRComponent extends HTMLElement {

  model;
  MATCHTYPELIST;

  //생성자
  constructor(model, matchlist, isPrint){
    
    super();

    //moveable 및 selecto 타겟팅 클래스
    this.classList.add("drag");
    
    //좌표체계
    this.style.position = "absolute";

    //이벤트 추가
    this.ondblclick  = this.event_doubleclick;

    this.isprint = isPrint;
    this.MATCHTYPELIST = matchlist;
    this.model = model;
    this.model.TEMP_POSX   = this.model.LAYOUT_POSX;
    this.model.TEMP_POSY   = this.model.LAYOUT_POSY;
    this.model.TEMP_WIDTH  = this.model.LAYOUT_WIDTH;
    this.model.TEMP_HEIGHT = this.model.LAYOUT_HEIGHT;
  
      //컬러
      if(model.COMPONENT_TYPE == 1){
        if(isPrint){
          this.contentEditable = false;
          this.style.verticalAlign = "middle";
          this.style.textAlign = "center";
          this.style.display = "table-cell";
          this.style.lineHeight = "120%";
        }else{

          this.contentEditable = true;
          this.style.verticalAlign = "middle";
          this.style.textAlign = "center";
          this.style.display = "table-cell";
          this.style.lineHeight = "120%";
        }
      }
      
      //this.style.pointerEvents = "none"; //마우스 이벤트 무시
      //this.model = model;                //여기에 객체를 강제로 붙여놓는다. 그래야 이벤트에서 접근됨.
      //this.MATCHTYPELIST = matchlist;
      
      //커서
      //this.style.cursor    = "hand";

      //사이즈 위치 관련
      //this.style.position  = "absolute";
      this.style.height    = this.model.LAYOUT_HEIGHT + "px";
      this.style.width     = this.model.LAYOUT_WIDTH  + "px";

      //transform을 사용할 경우 (ROTATE, SCALE 기능이 필요하면 transform 사용)
      this.style.transform = `translateX(${this.model.LAYOUT_POSX}px) translateY(${this.model.LAYOUT_POSY}px) rotate(${this.model.ROTATE}deg)`;

      //배경 처리
      if(model.COMPONENT_TYPE == 0){
        if(this.model.BGTYPE == 0){
          //컬러 배경
          this.style.backgroundColor = "#"+this.model.BGCOLOR;
        }else{
            //이미지 배경
            this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = "url('"+this.model.IMG+"')"
            this.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 1){        
        if(this.model.BGTYPE == 0){
          //컬러 배경
          this.style.backgroundColor = "#"+this.model.BGCOLOR;
        }else{
            //이미지 배경
            this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = "url('"+this.model.IMG+"')"
            this.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 2){
        //QR코드
        if(this.isprint){
          //여기서 QR코드 생성
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          //this.style.backgroundRepeat = "no-repeat";
        }else{
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          this.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 3){
        if(this.isprint){
          //여기서 포토 생성
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          //this.style.backgroundRepeat = "no-repeat";
        }else{
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          this.style.backgroundImage = `url(${require('../assets/photosample.png')})`
          //this.style.backgroundImage = `url(${require('../assets/photosample.png')})`
          //this.style.backgroundRepeat = "no-repeat";
        }
      }else if(model.COMPONENT_TYPE == 4){
        //바코드
        if(this.isprint){
          //여기서 QR코드 생성
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          //this.style.backgroundRepeat = "no-repeat";
        }else{
          this.style.backgroundColor = "#ffffff";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
          this.style.backgroundRepeat = "no-repeat";
          this.style.backgroundImage = `url(${require('../assets/barcodesample.png')})`
          //this.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
          //this.style.backgroundRepeat = "no-repeat";
        }
      }

      this.style.verticalAlign   = "middle";
      this.style.fontFamily      = this.model.TEXTFONT;
      this.style.fontSize        = this.model.TEXTSIZE + "px";
      this.style.color           = "#"+this.model.TEXTCOLOR;
      this.style.textAlign       = this.model.TEXTALIGN
      this.style.verticalAlign   = "middle";
      
      //font size 10px이하 호환하기 (기본적으로 10px이하는 반영이 안됨.)
      this.style.webkitTextSizeAdjust = "none";

      //텍스트 줄바꿈
      this.style.display         = "flex";
      this.style.flexDirection   = "column";
      this.style.justifyContent  = "center";
      this.style.whiteSpace      = "pre";
      
      //텍스트 값 매칭
      if(isPrint){
        this.setMatchTextValueDiv();
      }else{
        this.setMatchTextValue();
      }
      
      this.style.userSelect = "none";  //요걸 해줘야 드래그시 텍스트가 자꾸 드래그 되던 현상이 해결됨.
      this.mode = "none"; //이동 및 스케일에 따른 모드

      //이벤트 처리
      this.onkeyup     = this.focusoutevent;

  }


  //컴포넌트 더블 클릭시
  // eslint-disable-next-line no-unused-vars
  event_doubleclick(e){
    
    if(this.model == null || this.model == undefined){
      return;
    }     
    if(this.model.COMPONENT_TYPE == 1 && this.model.TEXTMATCH == "INPUT"){
      this.style.pointerEvents = "auto"; //마우스 이벤트 처리
      this.focus({preventScroll: true});
    }
  }  

  createQRCODE(target){
    return new Promise(function(resolve, reject) {

      //여기서 QR코드 생성

      
      target.style.backgroundColor = "#00000000";
      target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
      target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
      target.style.backgroundRepeat = "no-repeat";
      //target.style.backgroundRepeat = "no-repeat";

      if(target.MATCHTYPELIST[11].name){
        QRCode.toDataURL(String(target.MATCHTYPELIST[21].name), { margin:0, width:parseInt(target.model.LAYOUT_WIDTH)})
        .then(url=>{
          //console.log("create qr width : " + target.model.LAYOUT_WIDTH + " / " + url);
          target.style.backgroundImage = "url('"+url+"')";
          //target.style.backgroundImage = "url('"+url+"')";
          resolve(true);
        })
        .catch(error=>{
          console.log("qr error : " + error);
          reject(false);
        });
      }else{
        target.style.backgroundImage = `url(${require('../assets/qrsample.png')})`;
        //target.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
      }

    });
  }

  createQRCODETEMP(target){

    return new Promise(function(resolve, reject) {

      //디자인 테스트용 qr생성
      try{
        
        console.log("createQRCODETEMP");

        target.style.backgroundColor = "#00000000";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        target.style.backgroundRepeat = "no-repeat";

        resolve(true);
      }catch(error){
        console.log("createQRCODETEMP error: " + error);
        reject(false);
      }

    });
  }



  createBARCODE(target, value){
    return new Promise(function(resolve, reject) {

      //여기서 바코드 생성
      try{

        target.style.backgroundColor = "#00000000";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundRepeat = "no-repeat";
        //target.style.backgroundRepeat = "no-repeat";

        //맵핑값이 있어야 하고 혹시나 파싱에러 날 수 있어서 catch함.
        if(value != null && value != undefined && value.length > 0){
          try{
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, value, {format:'CODE39', margin:0, displayValue:false});
            const barcodeDataUrl = canvas.toDataURL("image/png");
            target.style.backgroundImage = `url(${barcodeDataUrl})`;
          }catch(error){
            console.log(error);
          }
        }

        resolve(true);

      }catch(error){
        reject(false);
      }

    });
  }  

  //테스트용
  createBARCODETEMP(target){

    return new Promise(function(resolve, reject) {

      //디자인 테스트용 qr생성
      try{


        target.style.backgroundColor = "#00000000";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundRepeat = "no-repeat";
        //target.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        //target.style.backgroundRepeat = "no-repeat";

        const canvas = document.createElement('canvas');
        JsBarcode(canvas, '1234567890', {format:'CODE39', fontSize: 0});
        const barcodeDataUrl = canvas.toDataURL("image/png");
        target.style.backgroundImage = `url(${barcodeDataUrl})`;

        resolve(true);
      }catch(error){
        reject(false);
      }

    });
  }


  createPHOTO(target, photourl){
    //console.log("createPHOTO...1");
    return new Promise(function(resolve, reject) {
      //여기서 포토생성
      try{


        target.style.backgroundColor = "#00000000";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundImage = "url('"+photourl+"')";
        target.style.backgroundRepeat = "no-repeat";

        //target.style.backgroundRepeat = "no-repeat";
        //target.style.backgroundImage = "url('"+photourl+"')"
        resolve(true);
      }catch(exc){
        reject(false);
      }
    });
  }

  createPHOTOTEMP(target){
    return new Promise(function(resolve, reject) {

      //디자인 테스트용 포토생성
      try{


        target.style.backgroundColor = "#00000000";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundSize = target.model.LAYOUT_WIDTH + "px " + target.model.LAYOUT_HEIGHT + "px";
        target.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        target.style.backgroundRepeat = "no-repeat";

        //target.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //target.style.backgroundRepeat = "no-repeat";
        resolve(true);
      }catch(error){
        reject(false);
      }

    });
  }

  //유니크값 생성
  createRandomValue(){
      var random = Math.random().toString(16).slice(2,10);
      return '0x'+random;
  }
  
    
  focusoutevent(ev){
    //console.log("onkeyup : " + ev.target.innerText);
    
    // 텍스트 변경 전에 언두 저장
    if(ev.target.drBackground && ev.target.model.TEXTVALUE !== ev.target.innerText) {
        ev.target.drBackground.saveUndo("text");
    }
    
    ev.target.model.TEXTVALUE = ev.target.innerText;
    //console.log(ev.target.model.TEXTVALUE);
  }


  getSelected(){
    // Selecto가 선택 상태를 관리하므로 더 이상 필요 없음
    return false;
  }

  //키보드 입력
  setEditMode(target){
    //직접 입력인 경우만 더블클릭으로 입력 가능
    //console.log("setEditMode");
    if(target.model.COMPONENT_TYPE == 1 && target.model.TEXTMATCH == "INPUT"){
      target.style.pointerEvents = "auto"; //마우스 이벤트 처리
      target.focus({preventScroll: true});
    }
  }


/*******************************************/
// DRBackground가 호출하는 함수
/*******************************************/

updateTransElement(){
  if(this.model == null || this.model == undefined){
      return;
  }
  this.updateComponent();
  //this.style.cssText += "transform: translateX("+`${this.model.transx}px`+") translateY("+`${this.model.transy}px`+") rotate("+`${this.model.rotate}deg`+")";
  this.style.transform = `translateX(${this.model.TEMP_POSX}px) translateY(${this.model.TEMP_POSY}px) rotate(${this.model.ROTATE}deg)`;
}


updateTransElementAll(){
  if(this.model == null || this.model == undefined){
      return;
  }
  this.updateComponent();

  this.style.width  = `${this.model.LAYOUT_WIDTH}px`;
  this.style.height = `${this.model.LAYOUT_HEIGHT}px`;
  this.style.transform = `translateX(${this.model.TEMP_POSX}px) translateY(${this.model.TEMP_POSY}px) rotate(${this.model.ROTATE}deg)`;
  
}

  updateComponent(){

    if(this.model == null || this.model == undefined){
      return;
    }

    //this.model.TEMP_POSX   = this.model.LAYOUT_POSX;
    //this.model.TEMP_POSY   = this.model.LAYOUT_POSY;
    //this.model.TEMP_WIDTH  = this.model.LAYOUT_WIDTH;
    //this.model.TEMP_HEIGHT = this.model.LAYOUT_HEIGHT;

    this.style.width  = this.model.LAYOUT_WIDTH  + "px";
    this.style.height = this.model.LAYOUT_HEIGHT + "px";
    

    //텍스트나 이미지는 차일드 div에 추가해야함. 뒤집기 기능 때문에 수정

    //배경 처리
    if(this.model.COMPONENT_TYPE == 0 || this.model.COMPONENT_TYPE == 1){
      if(this.model.BGTYPE == 0){
          //컬러 배경
          this.style.backgroundColor = "#"+this.model.BGCOLOR;
      }else{
        //이미지 배경
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundImage = "url('"+this.model.IMG+"')"
        this.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 2){
      //QR코드
      if(this.isprint){
        //여기서 QR코드 생성
        //console.log("qr : " + this.MATCHTYPELIST[11]);

      }else{
        this.style.backgroundColor = "#ffffff";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        this.style.backgroundRepeat = "no-repeat";
        //this.style.backgroundImage = `url(${require('../assets/qrsample.png')})`
        //this.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 3){
      //포토
      if(this.isprint){
        //여기서 QR코드 생성
        console.log("photo : " + this.MATCHTYPELIST[21]);

      }else{
        this.style.backgroundColor = "#ffffff";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        this.style.backgroundRepeat = "no-repeat";
        //this.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //this.style.backgroundRepeat = "no-repeat";
      }
    }else if(this.model.COMPONENT_TYPE == 4){
      //바코드
      if(this.isprint){
        //여기서 QR코드 생성

      }else{
        this.style.backgroundColor = "#ffffff";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
        this.style.backgroundImage = `url(${require('../assets/barcodesample.png')})`
        this.style.backgroundRepeat = "no-repeat";
        //this.style.backgroundImage = `url(${require('../assets/photosample.png')})`
        //this.style.backgroundRepeat = "no-repeat";
      }

    }

    this.style.fontFamily      = this.model.TEXTFONT;
    this.style.fontSize        = this.model.TEXTSIZE + "px";
    this.style.color           = "#"+this.model.TEXTCOLOR;
    this.style.textAlign       = this.model.TEXTALIGN
    this.setMatchTextValue();
    
  }

  //textmatch에 따른 텍스트값 매칭
  setMatchTextValue(){

    if(this.model.COMPONENT_TYPE == 0){

      //이미지는 텍스트 없음
      this.innerText  = "";

    }else if(this.model.COMPONENT_TYPE == 1){

      if(this.model.TEXTMATCH == "INPUT"){
        this.innerText     = this.model.TEXTVALUE;
      }else if(this.model.TEXTMATCH == "1"){
        this.innerText     = this.MATCHTYPELIST[1].name;
      }else if(this.model.TEXTMATCH == "2"){
        this.innerText     = this.MATCHTYPELIST[2].name;
      }else if(this.model.TEXTMATCH == "3"){
        this.innerText     = this.MATCHTYPELIST[3].name;
      }else if(this.model.TEXTMATCH == "4"){
        this.innerText     = this.MATCHTYPELIST[4].name;
      }else if(this.model.TEXTMATCH == "5"){
        this.innerText     = this.MATCHTYPELIST[5].name;
      }else if(this.model.TEXTMATCH == "6"){
        this.innerText     = this.MATCHTYPELIST[6].name;
      }else if(this.model.TEXTMATCH == "7"){
        this.innerText     = this.MATCHTYPELIST[7].name;
      }else if(this.model.TEXTMATCH == "8"){
        this.innerText     = this.MATCHTYPELIST[8].name;
      }else if(this.model.TEXTMATCH == "9"){
        this.innerText     = this.MATCHTYPELIST[9].name;
      }else if(this.model.TEXTMATCH == "10"){
        this.innerText     = this.MATCHTYPELIST[10].name;
      }else if(this.model.TEXTMATCH == "11"){
        this.innerText     = this.MATCHTYPELIST[11].name;
      }else if(this.model.TEXTMATCH == "12"){
        this.innerText     = this.MATCHTYPELIST[12].name;
      }else if(this.model.TEXTMATCH == "13"){
        this.innerText     = this.MATCHTYPELIST[13].name;
      }else if(this.model.TEXTMATCH == "14"){
        this.innerText     = this.MATCHTYPELIST[14].name;
      }else if(this.model.TEXTMATCH == "15"){
        this.innerText     = this.MATCHTYPELIST[15].name;
      }else if(this.model.TEXTMATCH == "16"){
        this.innerText     = this.MATCHTYPELIST[16].name;
      }else if(this.model.TEXTMATCH == "17"){
        this.innerText     = this.MATCHTYPELIST[17].name;
      }else if(this.model.TEXTMATCH == "18"){
        this.innerText     = this.MATCHTYPELIST[18].name;
      }else if(this.model.TEXTMATCH == "19"){
        this.innerText     = this.MATCHTYPELIST[19].name;
      }else if(this.model.TEXTMATCH == "20"){
        this.innerText     = this.MATCHTYPELIST[20].name;
      }else{
        this.innerText     = "매칭필요"; 
      }

    }else{
      this.innerText     = "";
    }    

  }

  //textmatch에 따른 텍스트값 매칭 - 프린트용
  setMatchTextValueDiv(){

    if(this.model.COMPONENT_TYPE == 0){

      //이미지는 텍스트 없음
      this.innerText  = "";

    }else if(this.model.COMPONENT_TYPE == 1){
      
      if(this.model.TEXTMATCH == "INPUT"){
        this.innerText     = this.model.TEXTVALUE;
      }else if(this.model.TEXTMATCH == "1"){
        this.innerText     = this.MATCHTYPELIST[1].name;
      }else if(this.model.TEXTMATCH == "2"){
        this.innerText     = this.MATCHTYPELIST[2].name;
      }else if(this.model.TEXTMATCH == "3"){
        this.innerText     = this.MATCHTYPELIST[3].name;
      }else if(this.model.TEXTMATCH == "4"){
        this.innerText     = this.MATCHTYPELIST[4].name;
      }else if(this.model.TEXTMATCH == "5"){
        this.innerText     = this.MATCHTYPELIST[5].name;
      }else if(this.model.TEXTMATCH == "6"){
        this.innerText     = this.MATCHTYPELIST[6].name;
      }else if(this.model.TEXTMATCH == "7"){
        this.innerText     = this.MATCHTYPELIST[7].name;
      }else if(this.model.TEXTMATCH == "8"){
        this.innerText     = this.MATCHTYPELIST[8].name;
      }else if(this.model.TEXTMATCH == "9"){
        this.innerText     = this.MATCHTYPELIST[9].name;
      }else if(this.model.TEXTMATCH == "10"){
        this.innerText     = this.MATCHTYPELIST[10].name;
      }else if(this.model.TEXTMATCH == "11"){
        this.innerText     = this.MATCHTYPELIST[11].name;
      }else if(this.model.TEXTMATCH == "12"){
        this.innerText     = this.MATCHTYPELIST[12].name;
      }else if(this.model.TEXTMATCH == "13"){
        this.innerText     = this.MATCHTYPELIST[13].name;
      }else if(this.model.TEXTMATCH == "14"){
        this.innerText     = this.MATCHTYPELIST[14].name;
      }else if(this.model.TEXTMATCH == "15"){
        this.innerText     = this.MATCHTYPELIST[15].name;
      }else if(this.model.TEXTMATCH == "16"){
        this.innerText     = this.MATCHTYPELIST[16].name;
      }else if(this.model.TEXTMATCH == "17"){
        this.innerText     = this.MATCHTYPELIST[17].name;
      }else if(this.model.TEXTMATCH == "18"){
        this.innerText     = this.MATCHTYPELIST[18].name;
      }else if(this.model.TEXTMATCH == "19"){
        this.innerText     = this.MATCHTYPELIST[19].name;
      }else if(this.model.TEXTMATCH == "20"){
        this.innerText     = this.MATCHTYPELIST[20].name;
      }else{
        this.innerText     = "매칭필요"; 
      }
    }else if(this.model.COMPONENT_TYPE == 2){
      this.innerText     = "";
    }else if(this.model.COMPONENT_TYPE == 3){
      this.innerText     = "";
    }else if(this.model.COMPONENT_TYPE == 4){
      this.innerText     = "";
    }else{
      this.innerText     = "";
    }    


  }


  //이동 시작작업
  setMoveStart(target){
    target.model.TEMP_POSX = target.model.LAYOUT_POSX;
    target.model.TEMP_POSY = target.model.LAYOUT_POSY;
  }

  //이동
  setMove(target, mx, my){
    target.model.TEMP_POSX = target.model.TEMP_POSX + mx;
    target.model.TEMP_POSY = target.model.TEMP_POSY + my;
    
    
    //원본 - 부하 줄이려고 movestart, move end순으로 해서 인포창 갱신 부하 줄인다.
    //target.model.LAYOUT_POSX = target.model.LAYOUT_POSX + mx;
    //target.model.LAYOUT_POSY = target.model.LAYOUT_POSY + my;
    //target.style.transform = "translate("+target.model.LAYOUT_POSX+"px, "+target.model.LAYOUT_POSY+"px) scale("+target.model.SCALE+") rotateZ("+target.model.ROTATE+"deg)";
  }

  //이동끝
  setMoveEnd(target){
    target.model.LAYOUT_POSX = target.model.TEMP_POSX;
    target.model.LAYOUT_POSY = target.model.TEMP_POSY;
  }

  //너비 정하기 (풀사이즈)
  setWidth(w){
    this.model.TEMP_WIDTH  = w;
    this.style.width  = w + "px";
    this.model.TEMP_POSX  = 0;
    this.style.transform = `translateX(0px) translateY(${this.model.LAYOUT_POSY}px) rotate(${this.model.ROTATE}deg)`;
    this.model.TEMP_TEXTSIZE = this.model.TEXTSIZE;
    this.style.backgroundSize = w + "px " + this.model.LAYOUT_HEIGHT + "px";

    this.model.LAYOUT_POSX   = 0;
    this.model.LAYOUT_WIDTH  = w;

  }

  //중앙위치
  centerPos(dispwidth){
    var posx = (dispwidth/2)-(this.model.LAYOUT_WIDTH/2);
    this.model.TEMP_POSX  = posx;
    this.style.transform = `translateX(${posx}px) translateY(${this.model.LAYOUT_POSY}px) rotate(${this.model.ROTATE}deg)`;
    this.model.LAYOUT_POSX   = posx;
  }

  

}

//해당 js파일에서 DRComponent 클래스를 외부로 export하기 위한 코드
//클래스 외에도 함수나 변수를 외부로 export할 때 사용하며 import나 require로 사용
export default DRComponent;
customElements.define('dr-component', DRComponent);